import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals, pick } from "ramda";
import { extendedSystemStylesProps } from "@mixins";
import { TableContainer, Table, Caption, Tr, styledSystemKeys } from "./tableWrapper.styles.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function (props) {
  var columns = props.columns,
    rows = props.rows,
    caption = props.caption,
    Header = props.Header,
    renderRow = props.renderRow,
    borderSpacing = props.borderSpacing;
  var headers = columns.map(function (column, colIndex) {
    return /*#__PURE__*/_jsx(Header, {
      column: column,
      colIndex: colIndex
    }, column.id);
  });
  var rowsMarkup = rows.map(function (row, rowIndex) {
    return renderRow(row, rowIndex);
  });
  return /*#__PURE__*/_jsx(TableContainer, _objectSpread(_objectSpread({}, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: /*#__PURE__*/_jsxs(Table, {
      "aria-rowcount": rows.length + 1,
      "aria-colcount": columns.length,
      style: {
        borderSpacing: borderSpacing || ""
      },
      children: [/*#__PURE__*/_jsx(Caption, {
        className: "hidden-styles",
        children: caption
      }), /*#__PURE__*/_jsxs("tbody", {
        children: [/*#__PURE__*/_jsx(Tr, {
          "aria-rowindex": "1",
          "aria-colindex": "1",
          children: headers
        }), rowsMarkup]
      })]
    })
  }));
}, function (prev, curr) {
  return equals(pick(["columns", "rows", "caption", "Header"], prev), pick(["columns", "rows", "caption", "Header"], curr));
});